import * as actionTypes from '../actions';

const initialState = {
  currentStep: 1,
  waitingCount: 0,
  isRecording: false,
  isRecordingFinished: false,
  isRecordUploaded: false,
  isAssetsUploaded: false,
  isAssetsUploadFailure: false,
};

const genericOptionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CURRENT_STEP: {
      return {
        ...state,
        currentStep: action.payload,
      };
    }
    case actionTypes.IS_RECORDING: {
      return {
        ...state,
        isRecording: action.payload,
      };
    }
    case actionTypes.IS_RECORDING_FINISHED: {
      return {
        ...state,
        isRecordingFinished: action.payload,
      };
    }
    case actionTypes.IS_RECORD_UPLOADED: {
      return {
        ...state,
        isRecordUploaded: action.payload,
      };
    }
    case actionTypes.IS_ASSETS_UPLOADED: {
      return {
        ...state,
        isAssetsUploaded: action.payload,
      };
    }
    case actionTypes.IS_ASSETS_UPLOAD_FAILURE: {
      return {
        ...state,
        isAssetsUploadFailure: action.payload,
      };
    }
    case actionTypes.WAITING_COUNT: {
      return {
        ...state,
        waitingCount: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};

export default genericOptionsReducer;
